export default __webpack_public_path__ + "static/media/agentur.d433fa40.svg";